// extracted by mini-css-extract-plugin
export default {"button":"styles-module__button__src-labstep-web-components-Group-Action-Create-_TenN0"};